<template>
  <b-row :class="[
    { 'deliver-not-approved': !deliveryItem.isDeliveryApproved },
    expirationClass
  ]">
    <b-col md="3" sm="3">
      <div class="pb-2">
        <EcoConventionIcon :productType="deliveryItem.productType" />
        <span class="rawMaterialTypeName">{{deliveryItem.rawMaterialTypeName}}</span> <br>
        (<span class="batchNumber">{{ deliveryItem.batchNumber }}</span>)
      </div>
      <div v-b-tooltip.hover title="Kraj pochodzenia">
        <i class="fas fa-flag" /> {{ deliveryItem.countryName }}
      </div>
      <div v-b-tooltip.hover :title="expirationTooltip">
        <i class="fas fa-calendar" />
        {{ deliveryItem.rawMaterialExpireDate | moment("DD-MM-YYYY HH:mm") }}
        <span v-if="isExpired" class="badge badge-danger ml-1">Przeterminowany</span>
        <span v-else-if="isExpiringSoon" class="badge badge-warning ml-1">Wkrótce przeterminuje</span>
      </div>
    </b-col>
    <b-col sm="3">
      <div>Dostawy: <span class="deliveryWeight">{{ deliveryItem.deliveryWeight }}</span> <span>kg</span></div>
      <div>Użyta: <span class="usedWeight">{{ deliveryItem.usedWeight }}</span> <span>kg</span></div>
      <div v-b-tooltip.hover title="Data dostawy">
        <i class="fas fa-truck"></i>
        {{ deliveryItem.deliveryDate | moment("DD-MM-YYYY HH:mm") }}
      </div>
    </b-col>
    <b-col md="3" sm="3" :class="{ 'alert alert-warning': !isInvoice }">
      <b v-show="deliveryItem.invoiceType == 0">FV </b>
      <b v-show="deliveryItem.invoiceType == 1">WZ </b>
      <span class="invoiceNumber"> {{deliveryItem.invoiceNumber}}</span> <br />
      <div v-b-tooltip.hover title="Data wystawienia">
        <i class="fas fa-calendar" /> {{ deliveryItem.invoiceCreationDate | moment("DD-MM-YYYY HH:mm") }}
      </div>
      <span v-if="!isInvoice" v-b-tooltip.hover title="Zmień WZ na FV">
        <i class="far fa-edit cursor-pointer" @click="OpenChangeInvoiceNumberModal(deliveryItem)" />
      </span>
    </b-col>
    <b-col md="3" sm="3">
      {{ deliveryItem.producer.name }} <br />
      <div v-b-tooltip.hover title="Certyfikat przy przyjęciu">
        <i class="fas fa-file-certificate"></i>
        {{ selectActiveCertificate(deliveryItem) }}
      </div>
    </b-col>
    <b-col md="12">
      <b-button @click="toggleDetailsVisible()" variant="primary">Zobacz detale</b-button>
    </b-col>


    <b-col md="12 mt-2" v-show="isDetailsVisible">
      <b-card>
        <div class="card-text">
          <RawMaterialDetailsInfo :rawMaterialDetails="rawMaterialDetails" :isDataLoaded="isRawMaterialDetailsIsLoading"
            :deliveryItem="deliveryItem" @RemoveDeliveryItem="emitRemoveDeliveryItem"
            @OpenModalMaterialLoss="OpenModalMaterialLoss" />
        </div>
      </b-card>
    </b-col>
    <b-col md="12">
      <hr />
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
import rawMaterialsMixins from "../../../mixins/rawMaterials";
import floatMixins from "../../../mixins/floatHelper";
import RawMaterialDetailsInfo from "./RawMaterialDetailInfo.vue"
import EcoConventionIcon from '../../../common/ecoConventionIcon.vue'

export default {
  name: "ReceivedDeliverydeliveryItem",
  props: ["deliveryItem", "OpenChangeInvoiceNumberModal"],
  mixins: [rawMaterialsMixins, floatMixins],
  components: { RawMaterialDetailsInfo, EcoConventionIcon },
  data() {
    return {
      isDetailsVisible: false,
      rawMaterialDetails: {},
      isRawMaterialDetailsIsLoading: false,
      id: this._uid,
      isInvoice: this.deliveryItem.invoiceType == 0
    };
  },
  computed: {
    daysUntilExpiration() {
      const expirationDate = this.$moment(this.deliveryItem.rawMaterialExpireDate).startOf('day');
      const today = this.$moment().startOf('day');
      return expirationDate.diff(today, 'days');
    },
    isExpired() {
      return this.daysUntilExpiration < 0;
    },
    isExpiringSoon() {
      return this.daysUntilExpiration >= 0 && this.daysUntilExpiration <= 30;
    },
    isExpiringCritical() {
      return this.daysUntilExpiration >= 0 && this.daysUntilExpiration <= 7;
    },
    expirationClass() {
      if (this.isExpired) {
        return 'expiration-expired';
      } else if (this.isExpiringCritical) {
        return 'expiration-critical';
      } else if (this.isExpiringSoon) {
        return 'expiration-warning';
      }
      return '';
    },
    expirationTooltip() {
      if (this.isExpired) {
        return `Data ważności produktu - Wygasła ${Math.abs(this.daysUntilExpiration)} dni temu`;
      } else if (this.isExpiringSoon) {
        return `Data ważności produktu - Pozostało ${this.daysUntilExpiration} dni`;
      }
      return 'Data ważności produktu';
    }
  },
  methods: {
    emitRemoveDeliveryItem(itemId) {
      this.$emit("RemoveDeliveryItem", itemId);
    },
    toggleDetailsVisible() {
      const that = this;
      this.isDetailsVisible = !this.isDetailsVisible;
      that.isRawMaterialDetailsIsLoading = true;

      if (this.isDetailsVisible) {
        this.getRawMaterialDetails(this.deliveryItem.rawMaterialId)
          .then((res) => {
            that.rawMaterialDetails = res.data
          })
          .catch((err) => {
            var ref = that.$refs.loadingSpinner;
            ref.ShowErrorMessage("Wystąpił błąd aplikacji!", err);
          })
          .finally(() => {
            that.isRawMaterialDetailsIsLoading = false;
          });
      } else {
        this.rawMaterialDetails = {}
      }
    },
    setAlertIfNotInvoice(item) {
      var invoiceType = item.invoiceType;
      return invoiceType == 1 ? "alert alert-danger" : "";
    },
    selectActiveCertificate(item) {
      var deliveryDate = this.$moment(item.deliveryDate);
      const that = this;

      const certificates = item.producer.certificates.filter(
        (cert) =>
          deliveryDate >= that.$moment(cert.validFrom) &&
          deliveryDate <= that.$moment(cert.validTo)
      );

      const activeCertificate = certificates.slice(-1).pop();
      return activeCertificate ? activeCertificate.name : "";
    },
    OpenModalForRawMaterialDatailInfo(item) {
      var url =
        this.url.serverUrl + this.url.RawMaterial.GetRawMaterialDetailInfoById + item.id;
      var that = this;
      axios
        .get(url)
        .then(function (res) {
          that.$emit("ShowModalRawMaterialDatailInfo", res.data);
        })
        .catch(function (error) {
          console.log(error);
          var ref = that.$refs.loadingSpinner;
          ref.ShowErrorMessage("Wystąpił błąd aplikacji!", error);
        });
    },
    OpenModalMaterialLoss(item) {
      this.$emit("OpenModalMaterialLoss", item);
    },
  },
};
</script>

<style scoped>
.expiration-expired {
  background-color: #f8d7da !important;
  border-left: 4px solid #dc3545;
  padding-left: 10px;
}

.expiration-critical {
  background-color: #fff3cd !important;
  border-left: 4px solid #dc3545;
  padding-left: 10px;
}

.expiration-warning {
  background-color: #fff9e6 !important;
  border-left: 4px solid #ffc107;
  padding-left: 10px;
}
</style>
